module.exports = __webpack_public_path__ + "img/pointer.0498169e.png";